/* rpa.icon.svg.js */

'use strict';
module.exports = {
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path class="foreground-gl" d="M23,13c-0.5,0-1,0.5-1,1v1h-1v-5c0-1.7-1.3-3-3-3h-5.5V4.9C13.4,4.7,14,3.9,14,3c0-1.1-0.9-2-2-2s-2,0.9-2,2
	c0,0.9,0.6,1.7,1.5,1.9V7H6c-1.7,0-3,1.3-3,3v5H2v-1c0-0.5-0.5-1-1-1s-1,0.5-1,1v4c0,0.5,0.5,1,1,1s1-0.5,1-1v-1h1v3
	c0,1.7,1.3,3,3,3h12c1.7,0,3-1.3,3-3v-3h1v1c0,0.5,0.5,1,1,1s1-0.5,1-1v-4C24,13.4,23.5,13,23,13z M5,13.5C5,12.1,6.1,11,7.5,11
	s2.5,1.1,2.5,2.5S8.9,16,7.5,16S5,14.9,5,13.5z M15,18.5H9c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h6c0.3,0,0.5,0.2,0.5,0.5
	C15.5,18.3,15.3,18.5,15,18.5z M16.5,16c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S17.9,16,16.5,16z" fill="#53A9DD"/>
</svg>`
};
